import React from "react";
import { Link } from "react-router-dom";
import { Img } from "../../../components/shared/img";
import { Icon } from "@iconify/react/dist/iconify.js";
import { MAIN_PLANS } from "./main-plans";

import { useTranslationsById } from "../../../hooks/use-translations-by-id";
import { useLanguage } from "../../../hooks/use-language";


export const createList = ({ list, clase, textsPlans }) => {
    const options = []

    if (Array.isArray(list)) {
        list.map(elem => {
            options.push(<li className="secondary-font text-16 mb-2" key={elem?.default}>
                <Icon icon="ph:check-fat-fill" width="15" height="15" className={`mr-3 ${clase}`} />
                {
                    textsPlans.getText({
                        id: elem?.translationPath,
                        defaultText: elem?.default,
                    })
                }
            </li>)
        })
    }

    return options;
}

/**
 * Componente que retorna los planes de colegios y bibliotecas
 * @returns {JSXElement} PlansData
 */
const PlansData = ({ buttons }) => {
    const plans = [...MAIN_PLANS];
    const lang = useLanguage();
    const textsPlans = useTranslationsById({ mainSectionName: "planes_2026", language: lang });

    return (
        <div className="boxes mt-4">
            {plans.map((item) => {
                return (
                    <div key={item?.name} className={`box ${item?.class} ${buttons=== true ? 'p-3' : 'pt-3 px-3'} mb-4`}>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="img-box">
                                    <div className={`title p-3 d-flex justify-content-center
                                                align-items-center ${item?.class}`}>
                                        <h3 className="title5 secondary-font onsecondary-inverse--color ">{
                                            textsPlans.getText({
                                                id: item?.title?.translationPath,
                                                defaultText: item?.title?.default,
                                            })
                                        }</h3>
                                    </div>
                                    <div>
                                        <Img src={item?.img?.src} alt=" " aria-hidden={true} className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 pt-2 px-3">
                                <div>
                                    <p className="secondary-font onprimary--color"><strong>{
                                        textsPlans.getText({
                                            id: item?.description?.translationPath,
                                            defaultText: item?.description?.default,
                                        })
                                    }</strong></p>
                                    <ul className="list-options onprimary--color my-4">
                                        {createList({ list: item?.list, clase: item?.class, textsPlans: textsPlans })}
                                    </ul>
                                </div>

                                {buttons === true &&
                                    <div className="d-flex flex-column flex-sm-row flex-wrap justify-content-end align-items-center">
                                        <Link to={item?.link} className="btn-more text-16 mr-3 mb-3 mb-sm-0 focusable-red">
                                            {textsPlans.getText({
                                                id: 'button.more',
                                                defaultText: 'Conoce más'
                                            })}
                                        </Link>
                                        <Link to="/contacto" className="inverse-primary-button py-2 focusable-red">
                                            {textsPlans.getText({
                                                id: 'button.information',
                                                defaultText: 'Solicita información'
                                            })}
                                        </Link>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
};

export default PlansData;